import React, { useCallback, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { z } from 'zod'
import { Box } from '@mui/material'
import { t } from 'i18next'
import { useZodForm } from 'src/hooks/zod-form'
import { AppForm, FormSelectField, FormSubmitButton, FormTextField } from 'src/components/FormCore'
import { useGetAllUnAssignedResources } from 'src/api/task-resource'
import { CancelButton } from 'src/components/CancelButton'
import { IResource } from 'src/generated-types/resource'

const AddVesselTemporaryForm = ({ initialValues, onSubmit, customerId, pop, vessels }) => {
  const { t: translate } = useTranslation(['locality', 'common', 'task'])
  const { data: resources } = useGetAllUnAssignedResources(customerId)
  const [dataset, setDataSet] = React.useState<IResource[]>(resources?.items || [])
  useEffect(() => {
    const filteredDataset = resources?.items.filter(resource => {
      return !vessels?.some(vessel => vessel.resourceId === resource.id)
    })
    setDataSet(filteredDataset || [])
  }, [resources, vessels])
  const schema = z.object({
    resourceId: z.number(),
    description: z.string().max(400).optional().nullable(),
    resource: z.object({
      id: z.number(),
      name: z.string(),
    }),
    resourceDescription: z.string(),
    resourceUserId: z.string().optional().nullable(),
  })

  const form = useZodForm(schema, {
    defaultValues: {
      ...initialValues,
    },
  })

  const onSubmitHandle = useCallback(async formValues => {
    await onSubmit(formValues)
    pop()
  }, [])

  return (
    <AppForm form={form} onSubmit={onSubmitHandle} hasInitialValues={initialValues}>
      <FormSelectField
        variant="outlined"
        getOptionLabel={row => row.name}
        label={t('resource', { ns: 'task' })}
        data={dataset || []}
        name={'resource'}
        clearOnBlur={false}
        clearOnEscape={false}
        onChange={(evt, selectedValue) => {
          form.setValue('resource', selectedValue as IResource)
          form.setValue('resourceId', (selectedValue as IResource).id)
          form.setValue('resourceDescription', (selectedValue as IResource).description as string)
          form.setValue('resourceUserId', (selectedValue as IResource).userId as string)
        }}
      />

      <FormTextField
        name="resourceDescription"
        label={translate('resource-description', { ns: 'task' })}
        multiline
        rows={3}
        inputProps={{ readOnly: true }}
        focused
      />
      <FormTextField rows={5} multiline name="description" label={translate('description', { ns: 'common' })} />
      <Box className="flex justify-end gap-4 pt-4">
        <CancelButton onClick={pop}>{translate('cancel', { ns: 'common' })}</CancelButton>
        <FormSubmitButton createText={translate('add', { ns: 'common' })} />
      </Box>
    </AppForm>
  )
}

export default AddVesselTemporaryForm
